import { Tooltip } from "antd";
import React, { useState } from "react";
import { FaTrash } from "react-icons/fa6";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import { ConfigAssDigitalDocumentoPaginadaDTO } from "types/dto/groupsign/ConfigAssDigitalDocumentoPaginadaDTO";
import "./RenderRowsConfiguracaoDocumento.css";
import { FaPencilAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Rotas } from "constants/EnumRotas";
import CustomAlert from "shared/components/customAlert/CustomAlert";
import { useDeleteConfiguracaoAssinatura } from "hooks/groupsign/useDeleteConfiguracaoAssinatura";
import CustomButton from "shared/components/button/CustomButton";
import { getDocumentoFormatado } from "constants/EnumTipoDocumentoAssDigital";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";
import { TipoPermissao } from "constants/EnumTipoPermissao";

interface RenderRowsProps {
  configsDocumentos: ConfigAssDigitalDocumentoPaginadaDTO[];
}

export const RenderRowsConfiguracaoDocumento: React.FC<RenderRowsProps> = ({ configsDocumentos }) => {
  const navigate = useNavigate();
  const { mutate } = useDeleteConfiguracaoAssinatura();

  const [showAlert, setShowAlert] = useState(false);
  const [actionText, setActionText] = useState("");
  const [nomeDocumento, setNomeDocumento] = useState("");
  const [documentoExcluir, setDocumentoExcluir] = useState<ConfigAssDigitalDocumentoPaginadaDTO | null>(null);
  const { usuarioPossuiPermissao } = usePermissoesContext();
  const possuiPermissaoEditarConfiguracaoDocumento = usuarioPossuiPermissao(
            "configuracaoDocumentos",
            TipoPermissao.ALTERAR
  );
  const possuiPermissaoExcluirConfiguracaoDocumento = usuarioPossuiPermissao(
            "configuracaoDocumentos",
            TipoPermissao.EXCLUIR
  );

  const handleCancelAlert = () => setShowAlert(false);

  const handleConfirmAlert = () => {
    if (documentoExcluir) {
      mutate(documentoExcluir.id);
      setShowAlert(false);
    }
  };

  const handleExcluirClick = (config: ConfigAssDigitalDocumentoPaginadaDTO) => {
    setActionText("Excluir");
    setNomeDocumento(config.nomeCondominio ?? "");
    setDocumentoExcluir(config);
    setShowAlert(true);
  };
  
  return (
    <>
      {configsDocumentos?.map((config) => (
        <LinhaTabela id={`id-config-documento-${config.id}`} key={`key-config-documento-${config.id}`} className="linha-tabela">
          <RegistroTabela id={`nome-condominio-${config.id}`} key={`key-nome-condominio-${config.id}`} className="registro-tabela">
            <Tooltip title={config.nomeCondominio}>
              <span>{config.nomeCondominio}</span>
            </Tooltip>
          </RegistroTabela>

          <RegistroTabela id={`tipo-documento-${config.id}`} key={`key-tipo-documento-${config.id}`} className="registro-tabela">
            {getDocumentoFormatado(config.tipoDocumento)}
          </RegistroTabela>

          <RegistroTabela id={`data-configuracao-${config.id}`} key={`key-data-configuracao-${config.id}`} className="registro-tabela">
            {config.dataHoraConfiguracao
              ? `${new Date(config.dataHoraConfiguracao).toLocaleDateString()} às ${new Date(
                config.dataHoraConfiguracao
              ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
              : "-"}
          </RegistroTabela>

          <RegistroTabela id={`editar-${config.id}`} key={`key-editar-${config.id}`} className="registro-tabela registro-icones ">
            <div className="icones-container full-width">
              {possuiPermissaoEditarConfiguracaoDocumento && (
                <Tooltip title="Editar">
                  <FaPencilAlt
                    className="icon"
                    onClick={() => navigate(Rotas.ASSINATURA_DIGITAL_CONFIGURACAO_DOCUMENTO, { state: { config } })}
                  />
                </Tooltip>
              )}
              {possuiPermissaoExcluirConfiguracaoDocumento && (
                <Tooltip title="Excluir">
                  <FaTrash className="icon" onClick={() => handleExcluirClick(config)} />
                </Tooltip>
              )}
            </div>
          </RegistroTabela>
        </LinhaTabela>
      ))}
      <CustomAlert
        icon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "70px",
              height: "70px",
              backgroundColor: "#f7bfc0",
              borderRadius: "4px",
            }}
          >
            <FaTrash style={{ color: "#eb6e6f", fontSize: "30px" }} />
          </div>
        }
        iconColor="#f44336"
        open={showAlert}
        onClose={handleCancelAlert}
        onConfirm={handleConfirmAlert}
        title="Excluir documento"
        message={
          <>
            Tem certeza de que deseja excluir o documento "<strong>{nomeDocumento}</strong>" ? <br />
            Essa ação é irreversível.
          </>
        }
        subMessage="Caso deseje recuperá-lo após exclusão, será necessário criar um novo documento e configurá-lo novamente, incluindo todas as particularidades de cada condomínio."
        messageAlignment="left"
        height={window.innerHeight < 700 ? "70vh" : "55vh"} 
        buttons={
          <>
            <CustomButton
              id="cancelar-config-ass-digital-condominio"
              label="Cancelar"
              onClick={handleCancelAlert}
              size="lg"
              variant="outline-primary"
            />
            <CustomButton
              id="confirmar-config-ass-digital-condominio"
              label={`${actionText} documento`}
              onClick={handleConfirmAlert}
              size="lg"
              variant="primary"
            />
          </>
        }
      />

    </>
  );
};
